import { ReactElement } from "react";

import RemoveFactorProvider from "./providers/RemoveFactorProvider";

import MfaContainer from "./components/mfaContainer/MfaContainer";

const Mfa = (): ReactElement => {
  return (
    <RemoveFactorProvider>
      <MfaContainer />
    </RemoveFactorProvider>
  );
};

export default Mfa;
